import { formatDenominatedNumber } from 'helpers/mvx/formatters';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import BigNumber from 'bignumber.js';

export const ExpectedDistributionData = () => {
  const rewardDistribution = useSelector(
    (state: RootState) => state.rawVesta.rewardDistributionData
  );
  return (
    <div className='accordion-item' style={{ borderRadius: '0.625rem' }}>
      <h2 className='accordion-header' id='headingOne'>
        <button
          className='accordion-button text-center'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseOne'
          aria-expanded='true'
          aria-controls='collapseOne'
        >
          Show Expected Distribution Data
        </button>
      </h2>
      <div
        id='collapseOne'
        className='accordion-collapse collapse'
        aria-labelledby='headingOne'
        data-bs-parent='#accordionExample'
      >
        <div className='accordion-body'>
          <div className='table-responsive'>
            <table className='table'>
              <thead>
                <tr>
                  <th scope='col'>Address</th>
                  <th scope='col'>Is snapshotting?</th>
                  <th scope='col'>Farm weight share</th>
                  <th scope='col'>Raw VST estimated airdrop</th>
                </tr>
              </thead>
              <tbody>
                {rewardDistribution.data?.expectedRewardDistributionData?.map(
                  (data, index) => (
                    <tr key={`aggregated-reward-data-entry-${index}`}>
                      <th>{data.farm_address}</th>
                      <td>{data.is_snapshotting ? 'YES' : 'NO'}</td>
                      <td>
                        {formatDenominatedNumber(
                          data.farm_weight_share_percentage,
                          16
                        ).toLocaleString()}
                        %
                      </td>
                      <td>
                        {formatDenominatedNumber(data.raw_vst_estimated_amount)}
                      </td>
                    </tr>
                  )
                )}
              </tbody>
              <tfoot>
                <tr>
                  <th>Total</th>
                  <td></td>
                  <td>
                    {formatDenominatedNumber(
                      (
                        rewardDistribution.data
                          ?.expectedRewardDistributionData ?? []
                      )
                        .reduce(
                          (prev, crt) =>
                            (prev = prev.plus(
                              new BigNumber(crt.farm_weight_share_percentage)
                            )),
                          new BigNumber(0)
                        )
                        .toString(),
                      16
                    ).toLocaleString()}
                    %
                  </td>
                  <td>
                    {formatDenominatedNumber(
                      (
                        rewardDistribution.data
                          ?.expectedRewardDistributionData ?? []
                      )
                        .reduce(
                          (prev, crt) =>
                            (prev = prev.plus(
                              new BigNumber(crt.raw_vst_estimated_amount)
                            )),
                          new BigNumber(0)
                        )
                        .toString()
                    )}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
